<mat-form-field [floatLabel]="floatLabel" [appearance]="appearance" class="w-full"
    [class.mat-form-field-invalid]="!valid">
    <mat-label>{{(localize ? (label | translate) : label)}}{{(required)?'*':''}}</mat-label>
    <input matInput [id]="id" [(ngModel)]="value" (keyup)="keyUp($event)"
        placeholder="{{(localize ? (correctPlaceHolder | translate) : (placeHolder || label))}}{{(required)?'*':''}}" [disabled]="disabled"
        *ngIf="rows==1" [maxlength]="maxLength" [ngModelOptions]="{updateOn: updateOn}" [readonly]="readonly" />
    <textarea matInput [id]="id" [(ngModel)]="value" (keyup)="keyUp($event)"
        placeholder="{{(localize ? (correctPlaceHolder | translate) : (placeHolder || label))}}" [disabled]="disabled"
        *ngIf="rows!=1" [attr.rows]="rows" [maxlength]="maxLength" [ngModelOptions]="{updateOn: updateOn}"
        [readonly]="readonly"></textarea>
    <span matSuffix>
        <button mat-icon-button *ngIf="helpText != null">
            <mat-icon svgIcon="heroicons_outline:information-circle" (click)="tooltip.toggle()" #tooltip="matTooltip"
                [matTooltip]="helpTextLocalize ? (helpText | translate) : helpText">
            </mat-icon>
        </button>
    </span>
</mat-form-field>

<mat-error *ngIf="!valid">
    {{errorMessage}}
</mat-error>